import { packageVarsConsumer } from '@epihub/core/src/env';
import { z } from 'zod/v4';
import { packageConst } from './package';

export const vars = packageVarsConsumer({
  packageConst,
  parser: z.object({
    posthog: z.object({
      API_KEY: z.string(),
      PROJECT_ID: z.string(),
    }).optional(),
  }),
});
